import { IdentityProviderLogoType } from '@features/login/identity-provider';
import { IdentityProvider } from '../model/entity.model';

export const ADMIN = {
  maxInactiveInterval: 18000,
  email: 'admin@codeweaver.pl',
  fullName: 'Admin',
  authorities: ['ROLE_ADMIN']
};

export const IDENTITY_PROVIDER: IdentityProvider = {
  logo: {
    type: IdentityProviderLogoType.SVG,
    base64Content: ''
  }
};
